/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { EdgeWorkerService, createEdgeWorkerService } from 'qp-facade';
import { EdgeWorker } from 'qp-ui-interface';
import { environment } from '../../../../environments/environment';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { getXClientId } from '../../utils/deviceUtils';
import { StorefrontPolicyService } from '../firstlight/storefront-policy/storefront-policy.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { RegionAPIResult } from '../location/models/region-result';

// eslint-disable-next-line no-shadow
enum AppConfigKeys {
  CATALOG_SERVICE_KEY = 'catalogURL',
  UMS_SERVICE_KEY = 'umsURL',
  QPATUrl = 'qpatURL',
  IMAGE_RESIZE_SERVICE_KEY = 'imageResizeURL',
  VOD_METADATA_SERVICE_KEY = 'vodMetaDataURL',
  CLIENT_REGISTRATION_SERVICE_KEY = 'clientRegURL',
  CONTENT_AUTH_SERVICE_KEY = 'contentAuthURL',
  LINK_DEVICE_URL = 'linkDeviceURL',
  GUEST_FLAT_URL = 'guestFlatURL',
  ERROR_CODE_TRANSLATION = 'errorCodeTranslation',

  // PERSONALIZARION
  RECOMMENDATION_URL = 'recommendURL',
  PERSONALIZATION_SERVICE_KEY = 'personalizationURL',
  BOOKMARK_SERVICE_KEY = 'bookmarkURL',
  FAVORITE_SERVICE_KEY = 'favoriteURL',
  BECAUSE_YOU_WATCHED_LIMIT = 'bywLimit',
  PERSONALISED_NAME = 'personalisedName',
  // STOREFRONT
  STORE_FRONT_ID_KEY = 'storefrontId',
  STOREFRONT_SERVICE_KEY = 'storefrontURL',
  STOREFRONT_CONTENT_LIMIT = 'storefrontContentLimit',
  // HEARTBEAT
  HEARTBEAT_SERVICE_SERVICE_KEY = 'heartBeatURL',
  HEARTBEAT_SYNC_INTERVAL_KEY = 'heartBeatSyncInterval',
  // STATIC PAGES
  STATIC_URL = 'staticContentURL',
  HELP_CENTER_URL_KEY = 'helpCenterURL',
  PRIVACY_POLICY_URL_KEY = 'privacyPolicyURL',
  TC_PAGE_URL_KEY = 'termsAndConditionsURL',
  // LOCATION
  GEO_SERVICE_URL = 'geoLocationURL',
  ALLOWED_REGIONS = 'allowedRegions',
  // FL
  FL_CLIENT_ID = 'clientID',
  FL_CLIENT_SECRET = 'clientSecret',
  FL_X_CLIENT_ID = 'xClientId',
  // BOOKMARKS
  BOOKMARK_SYNC_INTERVAL_MS = 'bookmarkSyncIntervalMs',
  BOOKMARK_DELETE_THRESHOLD = 'bookmarkDeleteThreshold',
  // STREAM CONCURRENCY
  STREAM_CONCURRENCY_SERVICE_KEY = 'strConcurrencyURL',
  STREAM_CONCURRENCY_SYNC_INTERVAL_MS = 'streamConcurrencySyncIntervalMs',
  PLAYBACK_INPROGRESS = 'playbackReportingIntervalMs',
  // SEARCH
  NO_SEARCH_RESULTS_URL = 'noSearchResultsURL',
  SEARCH_POPULAR_CT = 'searchContentType',
  SEARCH_AR = 'searchAspectRatio',
  SEARCH_HISTORY_SERVICE_KEY = 'searchHistoryURL',
  // AUTH0
  AUTH0_URL = 'auth0Url',
  AUTH0_CLIENT_ID = 'auth0ClientID',
  AUTH0_CLIENT_SECRET = 'auth0ClientSecret',
  // CONVIVA
  CONVIVA_CUSTOMER_KEY = 'convivaCustomerKey',
  CONVIVA_GATEWAY_URL = 'convivaGatewayURL',
  CONVIVA_STG_CUSTOMER_KEY = 'convivaStgCustomerKey',
  //
  // CLEVERTAP
  ENABLE_CLEVERTAP = 'enableClevertap',
  // YOUBORA
  YOUBORA_ENABLE = 'youboraEnabled',
  // DATAZOOM
  DATAZOOM_TIZENKEY = 'datazoomTizenKey',
  DATAZOOM_LGKEY = 'datazoomLGKey',
  DATAZOOM_VIZIOKEY = 'datazoomVizioKey',
  DATAZOOM_CUSTOM_EVENTS_URL = 'datazoomCustomEventsConfigUrl',
  // GTM
  GTM_URL = 'gtmURL',
  GTM_TRACKING_ID = 'gtmTrackingID',
  GTM_AUTH = 'gtmAuth',
  GTM_PREVIEW = 'gtmPreview',
  // PLAYER CONFIGURATIONS
  MIN_BUFFER = 'minBuffer', // 2,
  MAX_BUFFER = 'maxBuffer', // 2,
  BUFFER_BEHIND = 'bufferBehind', // 3
  NETWORK_RETRIES = 'networkRetries', // - 2
  NETWORK_TIMEOUT = 'networkTimeout', // - 30
  STALL_TIMEOUT = 'stallTimeout', // - 5
  CONNECTION_TIMOUT = 'connectionTimeout', // - 10
  RETRY_DELAY = 'retryDelay', // - 1
  PREFERRED_BITRATE = 'preferredBitrate',
  INACCURATE_MANIFEST_TOLERANCE = 'inaccurateManifestTolerance',
  IGNORE_MIN_BUFFER_TIME = 'ignoreMinBufferTime',
  USE_NETWORK_INFORMATION = 'useNetworkInformation',
  MINTOTALBYTES = 'minTotalBytes',
  MINBYTES = 'minBytes',
  FASTHALFLIFE = 'fastHalfLife',
  SLOWHALFLIFE = 'slowHalfLife',
  BANDWIDTHUPGRADETARGET = 'bandwidthUpgradeTarget',
  BANDWIDTHDOWNGRADETARGET = 'bandwidthDowngradeTarget',
  SWITCHINTERVAL = 'switchInterval',
  IGNORESUGGESTEDPRESENTATIONDELAY = 'ignoreSuggestedPresentationDelay',
  DEFAULTPRESENTATIONDELAY = 'defaultPresentationDelay',

  LIVE_MIN_BUFFER = 'liveMinBuffer', // 2,
  LIVE_MAX_BUFFER = 'liveMaxBuffer', // 2,
  LIVE_BUFFER_BEHIND = 'liveBufferBehind', // 3
  LIVE_NETWORK_RETRIES = 'liveNetworkRetries', // - 2
  LIVE_NETWORK_TIMEOUT = 'liveNetworkTimeout', // - 30
  LIVE_STALL_TIMEOUT = 'liveStallTimeout', // - 5
  LIVE_CONNECTION_TIMOUT = 'liveConnectionTimeout', // - 10
  LIVE_RETRY_DELAY = 'liveRetryDelay', // - 1
  LIVE_PREFERRED_BITRATE = 'livePreferredBitrate',
  LIVE_INACCURATE_MANIFEST_TOLERANCE = 'liveInaccurateManifestTolerance',
  LIVE_IGNORE_MIN_BUFFER_TIME = 'liveIgnoreMinBufferTime',
  LIVE_USE_NETWORK_INFORMATION = 'liveUseNetworkInformation',
  LIVE_IGNORESUGGESTEDPRESENTATIONDELAY = 'liveIgnoreSuggestedPresentationDelay',
  LIVE_DEFAULTPRESENTATIONDELAY = 'liveDefaultPresentationDelay',
  LIVE_MINTOTALBYTES = 'liveMinTotalBytes',
  LIVE_MINBYTES = 'liveMinBytes',
  LIVE_FASTHALFLIFE = 'liveFastHalfLife',
  LIVE_SLOWHALFLIFE = 'liveSlowHalfLife',
  LIVE_BANDWIDTHUPGRADETARGET = 'liveBandwidthUpgradeTarget',
  LIVE_BANDWIDTHDOWNGRADETARGET = 'liveBandwidthDowngradeTarget',
  LIVE_SWITCHINTERVAL = 'liveSwitchInterval',

  STEP_PREDEFINED_MOVIE = 'stepPredefinedMovie', // 120
  STEP_PREDEFINED_TRAILER = 'stepPredefinedTrailer', //10
  STEP_PREDEFINED_SHOW = 'stepPredefinedShow', //10
  STEP_PREDEFINED_MOVIE_LG = 'stepPredefinedMovieLG', // 10
  STEP_PREDEFINED_TRAILER_LG = 'stepPredefinedTrailerLG', //10
  STEP_PREDEFINED_SHOW_LG = 'stepPredefinedShowLG', //10

  VIDEO_4K_TAG = 'video_4k_tag',
  AUDIO_DOLBY51_TAG = 'audio_dolby51_tag',
  AUDIO_51_TAG = 'audio_51_tag',
  // vizio
  VIZIO_HLS_CONFIG = 'safariBehaviourForLiveHlsVizio',
  VIZIO_BUFFER_TIMEOUT = 'bufferTimeoutMsVizio',
  VIZIO_PLAYBACK_Optimization = 'vizioPlaybackOptimization',
  MODAL_EXPLICIT_CONTENT = 'modalExplicitContentRatings', // TODO: change if LG approve the changes
  // PLAYER
  OAUTH_SERVICE_KEY = 'oAuthURL',
  WIDEVINE_CERTIFICATE_SERVICE_KEY = 'widevineCertBinUrl',
  ENABLE_KEYFRAME = 'enableKeyframes',
  ENABLE_CUEPOINTS = 'loadPlayerAdMarks',
  // EPG
  EPG_IDLE_TIME = 'epgIdleTime',
  // PROFILES
  RESTRICTED_RATINGS_FOR_KIDS = 'restrictedRatingsForKids',
  TIMEOUT_PROFILE_CHANGE = 'timeOutBetweenProfiles',
  ENABLE_RESET_PROFILE_PIN_ERROR = 'enableResetProfilePinOnError',
  // UP NEXT
  DISABLE_UPNEXT = 'disableUpNext',
  UP_NEXT_PERCENTAGE_THRESHOLD = 'upNextPercentageThreshold',
  // LANGUAGES
  LANGUAGES = 'languages',
  DEFAULT_LANGUAGE = 'defaultLanguage',
  // SEASONS AND EPISODES
  SEASONS_SORT_BY = 'seasonsSortBy',
  SEASONS_SORT = 'seasonsSort',
  EPISODES_SORT_BY = 'episodesSortBy',
  EPISODES_SORT = 'episodesSort',
  // DETAILS
  DETAILS_RELOAD_DELAY = 'detailsReloadDelay',
  DETAILS_EPISODES_PAGE_SIZE = 'detailsEpisodesPageSize',
  RECOMMENDATION_DETAILS_AR = 'recommendationDetailsAspectRatio',
  // PLAYER UI
  RECOMMENDATION_PLAYER_AR = 'recommendationPlayerAspectRatio',
  DISABLE_PLAYER_RECOMENDATIONS_ON_PAUSE = 'disablePlayerRecommendationsOnPause',
  // HERO
  AUTO_SCROLL_TIMEOUT_SEC = 'autoScrollTimeoutSec',
  USER_INACTIVITY_TIMEOUT_SEC = 'userInactivityTimeoutSec',
}

export type AppConfig = {
  [key in AppConfigKeys]: any;
};

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private appConfig!: AppConfig;
  private edgeWorkerService: EdgeWorkerService;

  get applicationConfig(): AppConfig {
    return this.appConfig;
  }

  set applicationConfig(config: AppConfig) {
    this.appConfig = config;
  }

  constructor(private localStorage: LocalStorageService, private policyService: StorefrontPolicyService) {
    this.edgeWorkerService = createEdgeWorkerService(environment.configUrl, { client: getXClientId() });
  }

  /**
   * getConfig() Get all the offers, location and configuration
   *
   * @returns void
   */
  public async getConfig(): Promise<void> {
    return this.getAppData();
  }

  public async getAppData(): Promise<void> {
    const edgeWorkerData: EdgeWorker = await this.edgeWorkerService.getEdgeWorkerData('comcast');
    this.storeEdgeWorkerData(edgeWorkerData);
  }

  private storeEdgeWorkerData(edgeWorkerData: EdgeWorker): void {
    this.storeConfig(edgeWorkerData);
    this.storeParsedRegion(edgeWorkerData);
  }

  private storeConfig(edgeWorkerData: EdgeWorker) {
    const appconfigNew: AppConfig = this.getParsedConfig(edgeWorkerData.config);
    this.appConfig = appconfigNew;
  }

  private storeParsedRegion(edgeWorkerData: EdgeWorker): void {
    const city = this.localStorage.getItem(LocalStorageKeys.CITY);
    const regionAPIResult: RegionAPIResult = {
      city: city || edgeWorkerData.geo.country,
      country: edgeWorkerData.geo.country,
      countryCode: edgeWorkerData.geo.country?.toUpperCase(),
      region: edgeWorkerData.geo.country,
      group: edgeWorkerData.geo.country,
      ipAddress: edgeWorkerData.geo.ip,
    };
    this.localStorage.setItem(LocalStorageKeys.LOCATION, JSON.stringify(regionAPIResult));
    this.localStorage.setItem(LocalStorageKeys.COUNTRY_CODE, regionAPIResult.countryCode);
    this.policyService.setRegion(regionAPIResult.countryCode);
  }

  private getParsedConfig(data: any): AppConfig {
    this.appConfig = this.getServiceConfig(data);
    this.applicationConfig = this.appConfig;
    return this.appConfig;
  }

  private getServiceConfig(payload: any): AppConfig {
    const appConfig: any = {};
    payload.forEach((item: any) => {
      appConfig[item.key] = item.value;
    });
    this.applicationConfig = appConfig;
    if (this.applicationConfig.xClientId) {
      environment.app.xClientID = this.applicationConfig.xClientId;
    }
    return appConfig as AppConfig;
  }
}
